module.exports = __webpack_public_path__ + "static/step_3_1-af0afcf848be3b8a134c5fff23f3f890.svg";